import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';

const STATUS_BADGE_INFO = {
  erfolgreich: { cls: 'bg-teal-50 text-teal-700', icon: '✓' },
  eingeschraenkt: { cls: 'bg-amber-50 text-amber-700', icon: '⚠' },
  fehlgeschlagen: { cls: 'bg-red-50 text-red-700', icon: '✗' },
};
const statusBadge = (status) => {
  const s = STATUS_BADGE_INFO[status] || STATUS_BADGE_INFO.fehlgeschlagen;
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${s.cls}`}>
      {s.icon} {status}
    </span>
  );
};

export default function DRReports() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/dr-reports').then(r => { setReports(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const formatDate = (d) => d ? new Date(d).toLocaleDateString('de-DE') : '—';

  return (
    <div className="p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-xl font-semibold text-gray-900">DR-Berichte</h1>
          <p className="text-sm text-gray-500 mt-0.5">Disaster-Recovery-Übungen</p>
        </div>
        <button
          onClick={() => navigate('/dr-reports/new')}
          className="flex items-center gap-2 bg-primary-600 hover:bg-primary-700 text-white text-sm font-medium px-4 py-2 rounded-lg transition-colors"
        >
          <span>+ Neuer Bericht</span>
        </button>
      </div>

      {loading ? (
        <div className="text-sm text-gray-500">Lädt...</div>
      ) : reports.length === 0 ? (
        <div className="bg-white border border-gray-200 rounded-xl p-12 text-center">
          <p className="text-gray-400 text-sm">Noch keine DR-Berichte vorhanden.</p>
          <button onClick={() => navigate('/dr-reports/new')} className="mt-4 text-primary-600 text-sm hover:underline">
            Ersten Bericht erstellen
          </button>
        </div>
      ) : (
        <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b border-gray-100 bg-gray-50">
                <th className="text-left px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wide">Nummer</th>
                <th className="text-left px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wide">Kunde</th>
                <th className="text-left px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wide">Gerät</th>
                <th className="text-left px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wide">Datum</th>
                <th className="text-left px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wide">Ergebnis</th>
                <th className="text-left px-4 py-3 text-xs font-medium text-gray-500 uppercase tracking-wide">Versendet</th>
                <th className="px-4 py-3"></th>
              </tr>
            </thead>
            <tbody>
              {reports.map(r => (
                <tr key={r.id} className="border-b border-gray-50 hover:bg-gray-50 cursor-pointer" onClick={() => navigate(`/dr-reports/${r.id}`)}>
                  <td className="px-4 py-3 font-mono text-xs text-gray-600">{r.report_number}</td>
                  <td className="px-4 py-3 font-medium text-gray-900">{r.customer_name}</td>
                  <td className="px-4 py-3 text-gray-600">{r.device_name}{r.device_label ? <span className="text-gray-400"> · {r.device_label}</span> : ''}</td>
                  <td className="px-4 py-3 text-gray-600">{formatDate(r.test_date)}</td>
                  <td className="px-4 py-3">{statusBadge(r.test_status)}</td>
                  <td className="px-4 py-3">
                    {r.sent_at
                      ? <span className="text-xs text-teal-600">✓ {formatDate(r.sent_at)}</span>
                      : <span className="text-xs text-gray-400">Ausstehend</span>}
                  </td>
                  <td className="px-4 py-3 text-right">
                    <button onClick={e => { e.stopPropagation(); navigate(`/dr-reports/${r.id}/edit`); }}
                      className="text-xs text-gray-400 hover:text-gray-600">Bearbeiten</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
